/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Feature_2Inputs */

const et_plan_visibility_feature_2 = /** @type {(inputs: Plan_Visibility_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rohkem õigeid inimesi jõuab sinu veebilehele`)
};

const en_plan_visibility_feature_2 = /** @type {(inputs: Plan_Visibility_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More of the right people reach your website`)
};

/**
* | output |
* | --- |
* | "More of the right people reach your website" |
*
* @param {Plan_Visibility_Feature_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_feature_2 = /** @type {((inputs?: Plan_Visibility_Feature_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Feature_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_feature_2(inputs)
	return en_plan_visibility_feature_2(inputs)
});